import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';
import { FormatService } from './format.service';

@Injectable({
    providedIn: 'root'
})
export class TranslatedToastrService {

    constructor(
        private toastrService: ToastrService,
        private translateService: TranslateService,
        private formatService: FormatService
    ) { }

    public info<ConfigPayload = any>(message: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>, additionalInformation?: string,): ActiveToast<any> {
        return this.toastrService.info(this.getFullMessage(message, additionalInformation), this.translateService.instant(title ? title : ""), { ...override, timeOut: 20000 });
    }

    public success<ConfigPayload = any>(message: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>, additionalInformation?: string): ActiveToast<any> {
        return this.toastrService.success(this.getFullMessage(message, additionalInformation), this.translateService.instant(title ? title : ""), { ...override, timeOut: 20000 });
    }

    public warning<ConfigPayload = any>(message: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>, additionalInformation?: string): ActiveToast<any> {
        const fullMessage = `${this.getFullMessage(message, additionalInformation)}<br>${this.formatService.formatDateTime(new Date())}`;
        return this.toastrService.warning(this.removeTemplateVariable(fullMessage), this.translateService.instant(title ? title : ""), { ...override, enableHtml: true, timeOut: 20000 });
    }

    public error<ConfigPayload = any>(message: string, title?: string, override: Partial<IndividualConfig<ConfigPayload>> = {}, additionalInformation?: string): ActiveToast<any> {
        const fullMessage = `${this.getFullMessage(message, additionalInformation)}<br>${this.formatService.formatDateTime(new Date())}`;
        return this.toastrService.error(this.removeTemplateVariable(fullMessage), this.translateService.instant(title ? title : ""), { ...override, enableHtml: true, timeOut: 20000 });
    }

    private getFullMessage(message: string, additionalInformation?: string): string {
        let extraMessage = "";
        if (additionalInformation) {
            extraMessage = " " + additionalInformation;
        }
        return this.translateService.instant(message ? message : "") + extraMessage;
    }

    private removeTemplateVariable(input: string): string {
        return input.replace(/\$\{[^}]+\}/g, "");
    }
}
